//
export function sleep(time) {
  return new Promise(resolve => setTimeout(resolve, time));
}



// WEBPACK FOOTER //
// ./src/utils.js